module.exports = __webpack_public_path__ + "img/garland_2.47bedc20.png";